import './App.css';
import Router from './routes/routes';
import store from './redux/store';
import { Provider } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchUserRole } from './redux/userSlice';

const AppWithRedux = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const accessToken = JSON.parse(localStorage.getItem('access_token'));
    if (accessToken) {
      dispatch(fetchUserRole(accessToken));
    }
  }, []);

  return (
    <div className="App">
      <Router />
    </div>
  );
};

function App() {
  return (
    <Provider store={store}>
      <AppWithRedux />
    </Provider>
  );
}

export default App;
